export enum PanicAppApiSuffixModels {
TARIFF = 'tariff',
TARIFF_DETAILS = 'tariff/details',
TRAIFF_LIST = 'tariff',
TRAIFF_INVOICE_PERIOD_DROPDOWN = 'ux/tariff/invoice-period',
TRAIFF_NO_AUTOGENERATED = 'tariff/tariffno-auto-generate',
TARIFF_DEFINITION='tariff-definition',
TARIFF_DEFINITION_DETAILS='tariff-definition/details',
TARIFF_DEFINITION_CATEGORY='tariff-definition/category',
UX_TARIFF_DEFINITION='/ux/tariff-definition/tariff',
TARIFF_DEFINITION_CHARGE_TYPES='ux/tariff-definition/charge-types',
TARIFF_GROUP='ux/tariff/tariff-group',
CORPORATE_CONTRACT='corporate-contract',
UX_CORPORATE_CONTRACT_TARIFF_PLAN='UX/corporate-contract/tariff-plan',
CORPORATE_CONTRACT_TARIFF_PLAN='corporate-contract/tariff-plan',
CORPORATE_CONTRACT_TARIFF_PROCESS_FILE='corporate-contract/process-file',
CORPORATE_CONTRACT_TARIFF_DETAILS='/corporate-contract/company-tariff-details',
GENERATE_TRACKING_URL='panicapp-browser/url-tracking-message',
SEND_OTP_VIA_SMS='panicapp-browser/send-otp',
SEND_SMS='panicapp-browser/send-sms',
VERIFY_OTP='panicapp-browser/verify-otp',
GET_THIRD_PARTY_DETAILS='panicapp-browser-detail',
GET_THIRD_PARTY_FEEDBACK_DETAILS='panicapp-browser/feedback-detail',
SUBMIT_THIRD_PARTY_FEEDBACK_DETAILS='panicapp-browser/feedback',
GET_INCIDENT_TYPES='ux/panicapp-browser/incident-types',
CORPORATE_CONTRACT_INVOICE ='corporate-contract-invoice',
CORPORATE_CONTRACT_INVOICE_PAYMENT = 'corporate-contract/invoice-payment',
}
